<template>
  <Alert type="success">
    Ваш запрос на смену пароля успешно отправлен. Сейчас придет письмо с инструкцией по смене пароля. Если письмо не появилось в вкладке "Входящие", то проверьте папку "Спам"
  </Alert>
</template>

<script>
import Alert from "../../alert/Alert.vue";

export default {
  name: "PasswordRecoveryFinish",
  components: {Alert}
}
</script>

<style scoped>

</style>